"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var bind_1 = require("../bind");
var I18n = require("i18n-js");
var qs = require("qs");
var sanitized_render_1 = require("./sanitized_render");
var url_helpers_1 = require("../url_helpers");
var csrf_form_1 = require("../csrf_form");
var react_tracking_1 = require("react-tracking");
var tracker_1 = require("../tracker");
var user_context_provider_1 = require("./user_context_provider");
var form_group_with_checkbox_1 = require("./form_group_with_checkbox");
var form_group_with_input_1 = require("./form_group_with_input");
var COMPONENT_NAME = 'SignupForm';
var SignupForm = /** @class */ (function (_super) {
    tslib_1.__extends(SignupForm, _super);
    function SignupForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            emailValue: '',
            emailConfirmValue: '',
            invalid: undefined,
        };
        return _this;
    }
    SignupForm.prototype.handleSubmit = function () {
        this.props.tracking.trackEvent({
            interaction: tracker_1.SUBMIT,
            context: this.props.trackContext,
        });
    };
    Object.defineProperty(SignupForm.prototype, "gdpr", {
        get: function () {
            return this.props.user.gdpr;
        },
        enumerable: true,
        configurable: true
    });
    SignupForm.prototype.emailsMatchError = function () {
        if (this.state.invalid) {
            return I18n.t('commons.signupForm.emailMatchError');
        }
    };
    SignupForm.prototype.emailsMatch = function () {
        // if the user hasn't entered values in the email fields
        // we don't want to annoy them with errors yet
        if (!this.state.emailValue || !this.state.emailConfirmValue)
            return true;
        return this.state.emailValue === this.state.emailConfirmValue;
    };
    SignupForm.prototype.validate = function () {
        this.setState({ invalid: !this.emailsMatch() });
    };
    SignupForm.prototype.checkInitialEmailState = function (_evt, data) {
        // this only updates validation on blur on the email confirm field.
        // we don't want errors popping up until
        // they've at least attempted to write values
        var _this = this;
        this.setState(data, function () {
            if (_this.state.invalid === undefined)
                _this.validate();
        });
    };
    SignupForm.prototype.checkExistingEmailError = function (data) {
        // this fires on any input change
        // but should only display an error if it's already been set
        var _this = this;
        this.setState(data, function () {
            if (_this.state.invalid !== undefined)
                _this.validate();
        });
    };
    SignupForm.prototype.authUrlParams = function () {
        return qs.stringify({
            redirect_to: this.props.redirectTo,
        });
    };
    SignupForm.prototype.renderAcceptTermsLabel = function () {
        if (this.gdpr) {
            var gdprTranslation = I18n.t('commons.signupForm.gdprAcceptTermsLabel', {
                termsLinkOpen: "<a href='" + url_helpers_1.TERMS_OF_USE_PATH + "'>",
                privacyLinkOpen: "<a href='" + url_helpers_1.PRIVACY_POLICY_PATH + "'>",
                linkClose: '</a>',
            });
            return React.createElement(sanitized_render_1.default, { html: gdprTranslation });
        }
        var translation = I18n.t('commons.signupForm.acceptTermsLabel', {
            termsLinkOpen: "<a href='" + url_helpers_1.TERMS_OF_USE_PATH + "'>",
            privacyLinkOpen: "<a href='" + url_helpers_1.PRIVACY_POLICY_PATH + "'>",
            linkClose: '</a>',
        });
        return React.createElement(sanitized_render_1.default, { html: translation });
    };
    /**
     * Because Enzyme doesn't propogate the onSubmit callback testing
     * that I don't muck with these inputs is tough. According to mdn's
     * docs https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox
     *
     * A checkbox will send a value of 'on' or undefined. We don't, nor should we
     * coerece these into truthy values. On the Rails side we'll make sure that 'on'
     * and nil represet the falsy and truthy values that they should.
     *
     * So this will come across as `user[accept_terms]=on` in the FormParams
     * or `user[accept_terms]=` if it isn't set (or the value won't be sent at all)
     *
     * Here is the corresponding Rails PR:
     */
    SignupForm.prototype.renderTermsCheckboxes = function () {
        return (React.createElement("div", null,
            React.createElement(form_group_with_checkbox_1.default, { label: I18n.t('commons.signupForm.newsletterLabel'), inputName: "user[weekly_newsletter]", defaultChecked: !this.gdpr }),
            React.createElement(form_group_with_checkbox_1.default, { label: this.renderAcceptTermsLabel(), inputName: "user[accept_terms]", defaultChecked: !this.gdpr, required: true, tagRequired: true })));
    };
    SignupForm.prototype.renderHeader = function () {
        if (!this.props.shouldRenderHeader) {
            return null;
        }
        return (React.createElement("h4", { className: "signup-signin__header" }, I18n.t('commons.signupForm.signupHeader')));
    };
    SignupForm.prototype.renderTerms = function () {
        return (React.createElement("div", null, this.renderTermsCheckboxes()));
    };
    SignupForm.prototype.renderGdprTerms = function () {
        return (React.createElement("div", { className: "signup-signin__form__gdpr" },
            this.renderTermsCheckboxes(),
            React.createElement("input", { type: "hidden", name: "user[terms_type]", value: "gdpr" })));
    };
    SignupForm.prototype.renderGdprExplanation = function () {
        var translation = I18n.t('commons.signupForm.gdprReverbProcessesData', {
            gdprPolicyLinkOpen: "<a target='_blank' href='" + url_helpers_1.GDPR_POLICY_PATH + "'>",
            linkClose: '</a>',
        });
        return (React.createElement("div", { className: "signup-signin__form__gdpr__explanation" },
            React.createElement("hr", { className: "mtb-1" }),
            React.createElement("h4", { className: "signup-signin__form__gdpr__explanation__title" }, I18n.t('commons.signupForm.gdprHowReverbUsesData')),
            React.createElement("p", { className: "signup-signin__form__gdpr__explanation__subtext" },
                React.createElement(sanitized_render_1.default, { html: translation }))));
    };
    SignupForm.prototype.render = function () {
        return (React.createElement("div", null,
            this.renderHeader(),
            React.createElement(csrf_form_1.default, { action: "/signup?" + this.authUrlParams(), method: "post", onSubmit: this.handleSubmit, "data-disable-auto-validation": "true" // block forms.js handling
             },
                React.createElement("div", { className: "g-container scaling-mb-2" },
                    React.createElement("div", { className: "g-col-6" },
                        React.createElement(form_group_with_input_1.default, { label: I18n.t('commons.signupForm.firstNameLabel'), inputName: "user[first_name]", autoComplete: "given-name", autoFocus: true, required: true })),
                    React.createElement("div", { className: "g-col-6" },
                        React.createElement(form_group_with_input_1.default, { label: I18n.t('commons.signupForm.lastNameLabel'), inputName: "user[last_name]", autoComplete: "family-name", required: true }))),
                React.createElement(form_group_with_input_1.default, { label: I18n.t('commons.signupForm.emailLabel'), inputType: "email", inputName: "user[email]", fieldName: "emailValue", autoComplete: "email", value: this.state.emailValue, updateField: this.checkExistingEmailError, required: true }),
                React.createElement(form_group_with_input_1.default, { label: I18n.t('commons.signupForm.emailConfirmLabel'), inputType: "email", inputName: "emailConfirmValue", autoComplete: "email", errorText: this.emailsMatchError(), value: this.state.emailConfirmValue, updateField: this.checkExistingEmailError, onBlur: this.checkInitialEmailState, required: true }),
                React.createElement(form_group_with_input_1.default, { label: I18n.t('commons.signupForm.passwordLabel'), helpText: I18n.t('commons.signupForm.passwordTip', { minLength: 8 }), inputName: "user[password]", inputType: "password", autoComplete: "new-password", required: true }),
                this.gdpr && this.renderGdprTerms(),
                React.createElement("div", { className: "scaling-mtb-2" },
                    React.createElement("input", { type: "submit", value: I18n.t('commons.signupForm.signUp'), className: "button button--orange width-100", disabled: !this.emailsMatch() })),
                !this.gdpr && this.renderTerms()),
            this.gdpr && this.renderGdprExplanation(),
            React.createElement("hr", { className: "mtb-2" }),
            React.createElement("div", { className: "signup-signin__form__facebook" },
                React.createElement("a", { className: "signup-signin__form__facebook__link", href: url_helpers_1.FACEBOOK_AUTH_PATH + "?" + this.authUrlParams() }, I18n.t('commons.signupForm.facebookSignup')))));
    };
    SignupForm.defaultProps = {
        shouldRenderHeader: true,
        trackName: 'SigninForm',
    };
    tslib_1.__decorate([
        bind_1.default
    ], SignupForm.prototype, "handleSubmit", null);
    tslib_1.__decorate([
        bind_1.default
    ], SignupForm.prototype, "checkInitialEmailState", null);
    tslib_1.__decorate([
        bind_1.default
    ], SignupForm.prototype, "checkExistingEmailError", null);
    SignupForm = tslib_1.__decorate([
        react_tracking_1.default({ componentName: COMPONENT_NAME })
    ], SignupForm);
    return SignupForm;
}(React.Component));
exports.SignupForm = SignupForm;
exports.default = user_context_provider_1.withUserContext(SignupForm);
//# sourceMappingURL=signup_form.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/signup_form.js
// module id = QoR/
// module chunks = 20 21